














import { Vue, Component } from 'vue-property-decorator'
import { namespace } from 'vuex-class'
import Overlay from '../Overlay.vue'
import Spinner from '../BaseSpinner.vue'

const cart = namespace('cart')
const intlShippingErrorMessage = 'Due to the situation we are seeing significant international delays. We are limiting international shipping for the time being. We apologize for any inconvenience.';

@Component({ components: { Overlay, Spinner } })
export default class PayPal extends Vue {
  @cart.State processingPaypal: boolean
  @cart.State paypalCapturing: boolean
  @cart.State paypalOrderInit: PayPalOrderInit
  @cart.State shippingInvalidCountries: string[]
  @cart.State isVip: boolean
  @cart.Mutation setPaypalAvailable: (status: boolean) => void
  @cart.Mutation setProcessingPaypal: (status: boolean) => void
  @cart.Mutation setPaypalCapturing: (status: boolean) => void
  @cart.Mutation setGlobalError: (message: string) => void
  @cart.Action createPaypalOrder: () => Promise<void>
  @cart.Action updatePaypalShipping: (shipping: PayPalShippingAddress) => Promise<void>
  @cart.Action completePaypalOrder: (info: any) => Promise<void>

  paypalPoll: number

  async mounted () {
    this.paypalPoll = setInterval(this.paypalCallback, 150)
  }

  paypalCallback () {
    console.log('paypalCallback: available', this.$refs.paypal, this.$refs)
    if (window.paypal && window.paypal.Buttons && this.$refs.paypal) {
      this.setPaypalAvailable(true)
      window.clearInterval(this.paypalPoll)

      window.paypal.Buttons({
        locale: 'en-US',
        style: {
          size: 'responsive',
          color: 'silver',
          shape: 'rect',
          label: 'checkout',
          tagline: false
        },
        createOrder: async (data: any, actions: PayPalActions) => {
          try {
            await this.createPaypalOrder()

            // have some sort of overlay

            if (this.paypalOrderInit.processed === true) {
              location.href = '/thankyou'
              return null
            }

            return this.paypalOrderInit.id
          } catch (error) {
            if (error instanceof Error) {
              this.setGlobalError(error.message)
            } else {
              this.setGlobalError('An unknown error occurred.')
            }
          }
        },
        onShippingChange: async (data: any, { resolve, reject }: PayPalActions) => {
          const shippingAcceptable = !this.shippingInvalidCountries.includes(data.shipping_address.country_code)

          if (!shippingAcceptable) {
            this.setGlobalError(intlShippingErrorMessage)
          } else {
            await this.updatePaypalShipping(data.shipping_address)
          }

          return shippingAcceptable ? resolve() : reject()
        },
        onCancel: () => {
          // hide the overlay
          this.setProcessingPaypal(false)
          this.setPaypalCapturing(false)
        },
        onError: (error: Error) => {
          // track the error
          this.setGlobalError(`Oh no! Something went wrong while processing your paypment: ${error?.message}`)
          this.setProcessingPaypal(false)
          this.setPaypalCapturing(false)
        },
        onApprove: async (data: any, actions: any) => {
          const details = await actions.order.capture()

          await this.completePaypalOrder({ data, details })
          this.setPaypalCapturing(true)
        }
      }).render(this.$refs.paypal)
    }
  }
}
